module.exports = __webpack_public_path__ + "img/stick_activites_canyoning.178dbcd3.svg";